import React, { Suspense, lazy } from 'react';
import { useInView } from 'framer-motion';
import Navbar from '../Section/Navbar';
import Home from '../Section/Home.jsx';

// Lazy load sections for performance
const Aboutus = lazy(() => import('../Section/Aboutus'));
const Projects = lazy(() => import('../Section/Projects'));
const Venture = lazy(() => import('../Section/Venture'));
const Skills = lazy(() => import('../Section/Skills'));
const CaseStudiesSection = lazy(() => import('../Section/CaseStudiesSection'));

// Simple wrapper to load sections asynchronously without breaking scroll anchors
const LazySection = ({ children }) => {
  return (
    <Suspense fallback={<div className="min-h-screen bg-[#08090b]" />}>
      {children}
    </Suspense>
  );
};

function MainPage() {
  return (
    <>
      <Navbar />
      <Home />
      <LazySection><Aboutus /></LazySection>
      <LazySection><Projects /></LazySection>
      <LazySection><Venture /></LazySection>
      <LazySection><CaseStudiesSection /></LazySection>
      <LazySection><Skills /></LazySection>
    </>
  );
}

export default MainPage;
